// removed by extract-text-webpack-plugin
module.exports = {"pageHeader":"antd-pro-page-header-pageHeader","wide":"antd-pro-page-header-wide","detail":"antd-pro-page-header-detail","row":"antd-pro-page-header-row","breadcrumb":"antd-pro-page-header-breadcrumb","tabs":"antd-pro-page-header-tabs","logo":"antd-pro-page-header-logo","title":"antd-pro-page-header-title","action":"antd-pro-page-header-action","content":"antd-pro-page-header-content","extraContent":"antd-pro-page-header-extraContent","main":"antd-pro-page-header-main"};


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/src/components/PageHeader/index.less
// module id = 261
// module chunks = 0